import { findingsColumns } from "../Findings/FindingsUtils";

export const modeOptions = {
  CREATE: "create",
  EDIT: "edit",
  READ: "read",
};

export const findingsTicketsColumns = [
  findingsColumns.ACCOUNT,
  findingsColumns.TITLE,
  findingsColumns.SCORE,
  findingsColumns.STATUS,
  findingsColumns.TICKET_STATUS,
  findingsColumns.TICKET_ID,
  findingsColumns.RESOURCES,
];

export const findingsWithoutTicketsColumns = [
  findingsColumns.ACCOUNT,
  findingsColumns.TITLE,
  findingsColumns.SCORE,
  findingsColumns.STATUS,
  findingsColumns.RESOURCES,
  findingsColumns.TICKET_ID,
];

export const queueStates = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
};

export const queueStatus = {
  SYNCED: { value: "SYNCED", text: "Synced", icon: "seem-icon-double-refresh" },
  NEVER_SYNCED: {
    value: "NEVER_SYNCED",
    text: "Never Synced",
    icon: "seem-icon-never-synced",
  },
  PAUSED: { value: "PAUSED", text: "Paused", icon: "seem-icon-pause" },
  ERROR: { value: "ERROR", text: "Error", icon: "seem-icon-error" },
  RUNNING: {
    value: "RUNNING",
    text: "Running...",
    icon: "seem-icon-spinner spinner",
  },
};

export const queueError = {
  ERROR_USER_INPUT: {
    typeText: "Fields input error",
    detailsExtraText:
      "To resolve this issue, edit the fields mentioned on the Edit screen> Mapping > Mapped Fields.",
  },
  ERROR_AUTH: {
    typeText: "Authentication error",
    detailsExtraText: "Authorization error.",
  },
  ERROR_INTERNAL: {
    typeText: "Internal error",
    detailsExtraText:
      "We're working to resolve this. For more information, contact Seemplicity Customer Services.",
  },
  PROVIDER_DISABLED: {
    typeText: "Provider disabled",
    detailsExtraText: "",
  },
  ERROR_RATE_LIMIT: {
    typeText: "Provider rate limit",
  },
  ERROR_PROVIDER_INTEGRATION: {
    typeText: "Provider error",
  },
  ERROR_RESOURCE_ACCESS: {
    typeText: "Resource access error",
  },
};

export const queuePriorities = {
  DEFAULT: "DEFAULT",
  SLA: "SLA",
};

export const systemRemediationQueues = {
  REJECTED: {
    name: "Rejected Ticket Findings",
    message: (
      <div className={"modal-text"}>
        This Queue shows Findings that were marked as{" "}
        <span className={"modal-live-text"}>Rejected</span>.
      </div>
    ),
  },
  PENDING: {
    name: "Pending Verification Findings",
    message: (
      <div className={"modal-text"}>
        This Queue shows Findings that were marked as{" "}
        <span className={"modal-live-text"}>Done</span> in the ticketing system,
        but are still shown as <span className={"modal-live-text"}>Open</span>{" "}
        in Seemplicity.
      </div>
    ),
  },
};

interface DatasourceFlaggedEdge {
  node: { is_datasource?: boolean | null };
}

// Datasource queues are system-managed and never listed on the Monitoring page;
// both the table rows and the tab counts must use this same rule.
export const excludeDatasourceQueues = <T extends DatasourceFlaggedEdge>(
  edges: T[] | null | undefined
): T[] => (edges ?? []).filter((edge) => !edge?.node?.is_datasource);
